module.exports = __webpack_public_path__ + "media/images/landing/icon-device-cb4b9b8d0210e3f7483c39611eed9363.svg";